<template>
	<form
		:class="[
			'styled-form',
			'styled-form--white-box',
			{'is-loading': isLoading}
		]"
		@submit.prevent="onSubmit"
	>

		<div v-if="isLoading" class="styled-form__overlay">
			<div class="preloader"></div>
		</div>

		<global-message v-if="errors.global" :value="errors.global"></global-message>

		<div class="styled-form__corset">
			<div class="styled-form__header">
				<h2 class="styled-form__title">Create a new password.</h2>
			</div>

			<form-input
					v-model="data.newPassword"
					type="password"
					name="newPassword"
					label="New password"
					:error="errors.newPassword"
					@keydown="passwordPolicyInline"
			/>

			<form-input
					v-model="data.confirmNewPassword"
					type="password"
					name="confirmNewPassword"
					label="Confirm new password"
					:error="errors.confirmNewPassword"
					@keydown="passwordMatchInline"
			/>

			<div class="text--center">
				<button
					class="btn btn--secondary"
					:disabled="isLoading"
					@click.prevent="cancel"
				>Cancel</button>
				<button class="btn" :disabled="isLoading">Update</button>
			</div>
		</div>

	</form>
</template>

<script>
	import GlobalMessage from '../messages/GlobalMessage.vue';
	import FormInput from '../formFields/FormInput.vue';

	export default {
		components: {
			GlobalMessage,
			FormInput
		},
		props: {
			submit: {
				type: Function,
				required: true
			},
			cancel: {
				type: Function,
				required: true
			}
		},
		data() {
			return {
				isLoading: false,
				data: {
					newPassword: '',
					confirmNewPassword: ''
				},
				errors: {}
			}
		},
		methods: {
			onSubmit() {
				this.errors = this.validate(this.data);

				if (Object.keys(this.errors).length === 0) {
					this.isLoading = true;
					this.submit(this.data).catch(errors => {
						this.isLoading = false;
						this.errors = errors;
					});
				}
			},
            validatePassword(password) {
                let errors = [];

                if (!password.length) {
                    errors.push('This field is required');
                }
                if (password.length < 8) {
                    errors.push('Password must be at least 8 characters');
                }
                if (!(/[a-z]/.test(password))) {
                    errors.push('Password must contain at least one lowercase letter');
                }
                if (!(/[A-Z]/.test(password))) {
                    errors.push('Password must contain at least one uppercase letter');
                }
                if (!(/[0-9]/.test(password))) {
                    errors.push('Password must contain at least one number');
                }
                /*
                if (!(/[!|@|#|$|%|^|&|*|(|)|-|_|]/.test(password))) {
                    errors.push('Password must contain at least one special character');
                }
                */

                return errors;
            },
            validatePasswordMatch(password, confirm){
                let errors = '';

                if(!confirm.length){
                    errors = 'This field is required';
                } else if(password !== confirm){
                    errors = 'The password you entered does not match';
                }
                return errors;
            },
            passwordPolicyInline() {
                this.$nextTick(() => {
                    if (this.data.newPassword.length > 0) {
                        let errors = this.validatePassword(this.data.newPassword);
                        if(errors.length){
                            this.errors.newPassword = this.passwordPolicyErrorFormat(errors);
                        }else{
                            delete this.errors.newPassword;
                        }
                    }else{
                        delete this.errors.newPassword;
                    }
                });
            },
            passwordPolicyErrorFormat(errors){
                let errorMsg = "<ul>";
                errors.forEach(function(item){
                    errorMsg = errorMsg + " <li> "+item+"</li>";
                });
                errorMsg = errorMsg + "</ul>";
                return errorMsg;
            },
            passwordMatchInline() {
                this.$nextTick(() => {
                    if (this.data.confirmNewPassword.length > 0) {
                        let errors = this.validatePasswordMatch(this.data.newPassword, this.data.confirmNewPassword);
                        if(errors !== "") {
                            this.errors.confirmNewPassword = errors;
                        }else{
                            delete this.errors.confirmnNewPassword;
                        }
                    }else{
                        delete this.errors.confirmNewPassword;
                    }
                });
            },
			validate(data) {
				const errors = {};

				if (!data.newPassword.length) {
					errors.newPassword = 'This field is required';
				} else if (data.newPassword.length < 8) {
					errors.newPassword = 'Password must be at least 8 characters';
				} else if (!(/[a-z]/.test(data.newPassword))) {
					errors.newPassword = 'Password must contain at least one lowercase letter';
				} else if (!(/[A-Z]/.test(data.newPassword))) {
					errors.newPassword = 'Password must contain at least one uppercase letter';
				} else if (!(/[0-9]/.test(data.newPassword))) {
					errors.newPassword = 'Password must contain at least one number';
				} else if (!(/[!@#$%^&*(),.?":{}|<>]/.test(data.newPassword))) {
					errors.newPassword = 'Password must contain at least one special character';
				} else if (data.newPassword !== data.confirmNewPassword) {
					errors.confirmNewPassword = 'The password you entered does not match';
				}

				return errors;
			}
		}
	};
</script>
